// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2k9C8","content":"GlobalSearch_content__1nUbs"};